<template>
  <div class="e-exam">
    <p class="e-exam-title">期末考试</p>
    <div class="e-exam-drys" v-if="topics">
      <dry :index="topicIndex" :content="topic.content" :course="topic.course" v-for="(topic, topicIndex) in topics" :key="topicIndex"/>
    </div>
    <loading v-else/>
  </div>
</template>

<script>
import api from '@/api/index';
import Dry from '@/components/study/dry'
import Loading from '@/components/loading'

export default {
  components: {
    Loading,
    Dry
  },
  data () {
    return {
      topics: null
    }
  },
  methods: {
  },
  async mounted () {
    let res = await api.getExam(this.$route.params.id, this.$route.params.type)
    this.topics = res.data
  }
}
</script>

<style lang="scss">
.e-exam{
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
  .e-exam-title{
    padding-bottom: 20px;
    line-height: 29px;
    font-size: 22px;
    color: #222427;
    font-weight: 700;
    border-bottom: 1px solid #E2E2E2;
    text-align: center;
  }
  .e-exam-drys{
    padding-top: 40px;
    .c-dry{
      margin-bottom: 40px;
    }
  }
}
</style>
